import { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';

export interface TextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'className'> {
  readonly className?: string;
  readonly invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid, ...rest },
  ref,
) {
  const cls = ['textarea', invalid ? 'textarea-invalid' : '', className ?? ''].filter(Boolean).join(' ');
  return <textarea ref={ref} className={cls} aria-invalid={invalid || undefined} {...rest} />;
});
